import React, { memo } from 'react';
import Svg, { Path } from 'react-native-svg';

export const IconStore = memo(({ color = '#545454', size = 24, ...rest }) => {
  return (
    <Svg width={size} height={size} viewBox="0 0 24 24" {...rest}>
      <Path
        fill={color}
        d="M4.06 3c-.43 0-.84.14-1.22.42-.38.28-.6.64-.7 1.08L1.11 8.91c-.25 1.09-.05 2.04.61 2.86l.28.28V19c0 .5.2 1 .61 1.39.41.39.89.61 1.39.61h14c.5 0 1-.2 1.39-.61.39-.41.61-.89.61-1.39v-6.95l.28-.28c.66-.82.86-1.77.61-2.86L19.86 4.5c-.13-.44-.36-.8-.73-1.08A1.88 1.88 0 0017.94 3H4.06m13.83 1.97l1.08 4.41c.09.43 0 .82-.28 1.17-.25.31-.56.45-.94.45-.31 0-.58-.1-.8-.34-.22-.23-.34-.5-.37-.82L15.97 5l1.92-.03M4.06 5h1.97l-.61 4.84C5.3 10.63 4.91 11 4.25 11c-.41 0-.72-.14-.94-.45-.28-.35-.37-.74-.28-1.17L4.06 5m3.99 0H10v4.7c0 .35-.11.65-.36.92-.25.26-.56.38-.94.38-.34 0-.63-.12-.86-.41-.23-.29-.34-.59-.34-.93V9.5L8.05 5M12 5h1.95l.55 4.5c.08.42 0 .77-.29 1.07-.26.3-.6.43-1.01.43-.31 0-.59-.12-.84-.38A1.29 1.29 0 0112 9.7V5m-5.55 7.05c.63.62 1.41.95 2.35.95.84 0 1.58-.33 2.2-.95.69.62 1.45.95 2.3.95.87 0 1.62-.33 2.25-.95.56.62 1.31.95 2.25.95h.23v6H4v-6h.25c.91 0 1.64-.33 2.2-.95z"
      />
    </Svg>
  );
});
